<section class="assignment" [formGroup]="form" *ngIf="form">
  <div class="bg-warn-lighter radius-2 p-4 mb-4" *ngIf="assignShipmentActionControl?.value !== AssignShipmentAction.Assign">
    <div class="brd-l brd-l-3 brd-warn pl-3">
      <h5 class="text-900 weight-semibold m-0 mb-1">{{ "sharedFeatures.ShipmentAssignment.ScheduleConflict" | translate }}</h5>

      <p class="h6 text-800 m-0" *ngIf="assignShipmentActionControl.value === AssignShipmentAction.Override">
        <ng-container *ngIf="truckRunningShipment && driverRunningShipment; else viewOneShipmentDetails">
          <span *ngIf="driverRunningShipment">
            <span>{{ ("sharedFeatures.ShipmentAssignment.TheDriver" | translate) | titlecase }}</span>
            <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
            <a

              [routerLink]="RoutesUtil.ShipmentsView.url({ id: driverRunningShipment?.id, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold text-900">#{{ driverRunningShipment?.id || "___" }}</span>
            </a>
            <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>
            <span class="weight-semibold text-900">{{ driverRunningShipment?.pickUpLocation?.city?.name || "___" }}</span>
            {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
            <span class="weight-semibold text-900">{{ driverRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
          </span>
          <br />
          <span *ngIf="truckRunningShipment">
            <span>{{ ("sharedFeatures.ShipmentAssignment.TheTruck" | translate) | titlecase }}</span>
            <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
            <a

              [routerLink]="RoutesUtil.ShipmentsView.url({ id: truckRunningShipment?.id, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold text-900">#{{ truckRunningShipment?.id || "___" }}</span>
            </a>
            <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>
            <span class="weight-semibold text-900">{{ truckRunningShipment?.pickUpLocation?.city?.name || "___" }}</span>
            {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
            <span class="weight-semibold text-900">{{ truckRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
          </span>
          <br />
          {{ "sharedFeatures.ShipmentAssignment.CloseShipment" | translate }} {{ (("sharedFeatures.ShipmentAssignment.ThoseShipments" | translate) |
          lowercase) | lowercase }}
        </ng-container>
        <ng-template #viewOneShipmentDetails>
          <span>{{"sharedFeatures.ShipmentAssignment.Kindly"| translate }}</span>
          <span>
            {{ (driverRunningShipment? "sharedFeatures.ShipmentAssignment.TheDriver" :"sharedFeatures.ShipmentAssignment.TheTruck" )| translate }}
          </span>
          <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
          <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>
          <span class="weight-semibold text-900">
            {{ driverRunningShipment? driverRunningShipment?.pickUpLocation?.city?.name : truckRunningShipment?.pickUpLocation?.city?.name || "___" }}
          </span>
          {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
          <span class="weight-semibold text-900">
            {{ driverRunningShipment? driverRunningShipment?.dropOffLocation?.city?.name : truckRunningShipment?.dropOffLocation?.city?.name|| "___" }}
          </span>
          {{ "sharedFeatures.ShipmentAssignment.CloseShipment" | translate }} {{ ("sharedFeatures.ShipmentAssignment.ThisShipment" | translate) |
          lowercase }}
          <a
            [routerLink]="RoutesUtil.ShipmentsView.url({ id: driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id, type: ShipmentsListType.All })"
            target="_blank"
          >
            <span class="weight-semibold text-900">#{{ driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id || "___" }}</span>
          </a>
        </ng-template>
        ?
      </p>

      <p class="h6 text-700 m-0" *ngIf="assignShipmentActionControl.value === AssignShipmentAction.AssignAndAutoStart">
        <ng-container *ngIf="truckRunningShipment && driverRunningShipment; else viewOneAutoStartDetails">
          <span *ngIf="driverRunningShipment">
            <span>{{"sharedFeatures.ShipmentAssignment.TheDriver" | translate | titlecase }}</span>
            <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
            <a

              [routerLink]="RoutesUtil.ShipmentsView.url({ id: driverRunningShipment?.id, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold text-900">#{{ driverRunningShipment?.id || "___" }}</span>
            </a>
            <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>
            <span class="weight-semibold text-900">{{ driverRunningShipment?.pickUpLocation?.city?.name|| "___" }}</span>
            {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
            <span class="weight-semibold text-900">{{ driverRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
            .
          </span>
          <br />
          <span *ngIf="truckRunningShipment">
            <span>{{"sharedFeatures.ShipmentAssignment.TheTruck" | translate | titlecase }}</span>
            <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
            <a

              [routerLink]="RoutesUtil.ShipmentsView.url({ id: truckRunningShipment?.id, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold text-900">#{{ driverRunningShipment?.id || "___" }}</span>
            </a>
            <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>
            <span class="weight-semibold text-900">{{ truckRunningShipment?.pickUpLocation?.city?.name|| "___" }}</span>
            {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
            <span class="weight-semibold text-900">{{ truckRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
            .
          </span>
          <br />
          {{ "sharedFeatures.ShipmentAssignment.ThisShipment" | translate }}
          <a
            *ngIf="shipmentId"
            [routerLink]="RoutesUtil.ShipmentsView.url({ id: shipmentId, type: ShipmentsListType.All })"
            target="_blank"
          >
            <span class="weight-semibold text-900">#{{ shipmentId || "___" }}</span>
          </a>
          {{ "sharedFeatures.ShipmentAssignment.WillStart" | translate }} {{ ("sharedFeatures.ShipmentAssignment.ThoseShipments" | translate) |
          lowercase}} {{"sharedFeatures.ShipmentAssignment.Are" | translate}}
        </ng-container>

        <ng-template #viewOneAutoStartDetails>
          <span>{{"sharedFeatures.ShipmentAssignment.Kindly"| translate }}</span>
          <span>
            {{ (driverRunningShipment? "sharedFeatures.ShipmentAssignment.TheDriver" :"sharedFeatures.ShipmentAssignment.TheTruck" )| translate }}
          </span>
          <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
          <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>
          <span class="weight-semibold text-900">
            {{ ( driverRunningShipment? driverRunningShipment?.pickUpLocation?.city?.name : truckRunningShipment?.pickUpLocation?.city?.name)|| "___" }}
          </span>
          {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
          <span class="weight-semibold text-900">
            {{(driverRunningShipment? driverRunningShipment?.dropOffLocation?.city?.name : truckRunningShipment?.dropOffLocation?.city?.name)|| "___" }}
          </span>
          .
          <br />
          {{ "sharedFeatures.ShipmentAssignment.ThisShipment" | translate }}
          <a
            *ngIf="shipmentId"
            [routerLink]="RoutesUtil.ShipmentsView.url({ id: shipmentId, type: ShipmentsListType.All })"
            target="_blank"
          >
            <span class="weight-semibold text-900">#{{ shipmentId || "___" }}</span>
          </a>
          {{ "sharedFeatures.ShipmentAssignment.WillStart" | translate }}
          <a
            [routerLink]="RoutesUtil.ShipmentsView.url({ id: driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id, type: ShipmentsListType.All })"
            target="_blank"
          >
            <span class="weight-semibold text-900">{{( driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id) || "___" }}</span>
          </a>
          {{"sharedFeatures.ShipmentAssignment.Is" | translate}}
        </ng-template>
        {{ "sharedFeatures.ShipmentAssignment.SuccessfullyDelivered" | translate }}
      </p>
    </div>
  </div>

  <!-- Same three options on the same control — each is now its own selectable card carrying a line
       of explanation, so the choice reads without having to know the flow. -->
  <div *ngIf="isViewActions">
    <mat-radio-group formControlName="assignShipmentAction" class="flex column gap-2">
      <mat-radio-button
        class="assignment__option brd brd-200 radius-2 px-4 py-3"
        [class.brd-primary]="assignShipmentActionControl?.value === AssignShipmentAction.Override"
        [class.bg-primary-lighter]="assignShipmentActionControl?.value === AssignShipmentAction.Override"
        [value]="AssignShipmentAction.Override"
      >
        <span class="d-block text-900 weight-medium">{{ "sharedFeatures.ShipmentAssignment.ConfirmOverride" | translate }}</span>
        <span class="d-block small text-500 mt-1">{{ "sharedFeatures.ShipmentAssignment.ConfirmOverrideHint" | translate }}</span>
      </mat-radio-button>

      <mat-radio-button
        class="assignment__option brd brd-200 radius-2 px-4 py-3"
        [class.brd-primary]="assignShipmentActionControl?.value === AssignShipmentAction.Assign"
        [class.bg-primary-lighter]="assignShipmentActionControl?.value === AssignShipmentAction.Assign"
        [value]="AssignShipmentAction.Assign"
      >
        <span class="d-block text-900 weight-medium">{{ "sharedFeatures.ShipmentAssignment.JustAssign" | translate }}</span>
        <span class="d-block small text-500 mt-1">{{ "sharedFeatures.ShipmentAssignment.JustAssignHint" | translate }}</span>
      </mat-radio-button>

      <mat-radio-button
        class="assignment__option brd brd-200 radius-2 px-4 py-3"
        [class.brd-primary]="assignShipmentActionControl?.value === AssignShipmentAction.AssignAndAutoStart"
        [class.bg-primary-lighter]="assignShipmentActionControl?.value === AssignShipmentAction.AssignAndAutoStart"
        [value]="AssignShipmentAction.AssignAndAutoStart"
      >
        <span class="d-block text-900 weight-medium">{{ "sharedFeatures.ShipmentAssignment.AssignAndAutoStart" | translate }}</span>
        <span class="d-block small text-500 mt-1">{{ "sharedFeatures.ShipmentAssignment.AssignAndAutoStartHint" | translate }}</span>
      </mat-radio-button>
    </mat-radio-group>

    <div class="mt-4" *ngIf="assignShipmentActionControl.value === AssignShipmentAction.Override">
      <mat-label class="asterisk-after weight-medium h6 text-900 d-block mb-2">
        {{ "sharedFeatures.ShipmentAssignment.Justification"| translate}}
      </mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <textarea type="text" rows="3" matInput formControlName="justification"></textarea>
        <mat-error *ngIf="justificationControl.touched && justificationControl.errors?.required">
          {{ "sharedFeatures.ShipmentAssignment.ErrorMessageRequired" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</section>
